import axios from "axios";
import { getTokenHeader } from "../../../helpers/commonHelper";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "Mapping",
  data() {
    return {
      actions: ["SEO", "Journalist", "Spannend", "Redakteur"],
      apiOptions: [],
      promptOptions: [],
      apiMap: {}, // shortId → name
      promptMap: {}, // shortId → name
      mappings: [],
      form: {
        action: "",
        apiShortId: "",
        promptShortId: "",
        shared: false
      },
      isEditing: false,
      editingId: null,
      showForm: false
    };
  },
  async created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const headers = getTokenHeader();
      const [apis, prompts, mappings] = await Promise.all([
        axios.get(`${env.prompts_api_client_url}api/eo-prompt/keys`, {
          params: { principal_id: this.currentPrincipal },
          headers
        }),
        axios.get(`${env.prompts_api_client_url}api/eo-prompt/prompts`, {
          params: { principal_id: this.currentPrincipal },
          headers
        }),
        axios.get(`${env.prompts_api_client_url}api/eo-prompt/mappings`, {
          params: { principal_id: this.currentPrincipal },
          headers
        })
      ]);

      this.apiOptions = apis.data;
      this.promptOptions = prompts.data;
      this.mappings = mappings.data;

      this.apiOptions = apis.data.map(a => ({
        ...a,
        name: a.shared ? `${a.name} (Shared)` : a.name
      }));

      this.promptOptions = prompts.data.map(a => ({
        ...a,
        name: a.shared ? `${a.name} (Shared)` : a.name
      }));

      // Create lookup maps
      this.apiMap = Object.fromEntries(
        apis.data.map(a => [a.shortId, { name: a.name, shared: a.shared }])
      );

      this.promptMap = Object.fromEntries(
        prompts.data.map(p => [p.shortId, { name: p.name, shared: p.shared }])
      );
    },
    async saveMapping() {
      if (
        !this.form.action ||
        !this.form.promptShortId ||
        !this.form.apiShortId
      )
        return;

      const headers = getTokenHeader();
      const params = {
        principal_id: this.currentPrincipal
      };
      await axios.post(
        `${env.prompts_api_client_url}api/eo-prompt/mappings`,
        this.form,
        { params, headers }
      );
      this.form = {
        action: "",
        apiShortId: "",
        promptShortId: "",
        shared: false
      };
      this.showForm = false;
      this.fetchData();
    },
    async updateMapping() {
      if (!this.editingId) return;
      try {
        const headers = getTokenHeader();
        const params = {
          principal_id: this.currentPrincipal
        };
        await axios.put(
          `${env.prompts_api_client_url}api/eo-prompt/mappings/${this.editingId}`,
          this.form,
          { params, headers }
        );
        await this.cancelEdit();
        await this.fetchData();
      } catch (err) {
        console.error("Failed to update API mapping:", err);
      }
    },
    async deleteMapping(id) {
      const headers = getTokenHeader();
      const params = {
        principal_id: this.currentPrincipal
      };
      await axios.delete(
        `${env.prompts_api_client_url}api/eo-prompt/mappings/${id}`,
        { params, headers }
      );
      this.fetchData();
    },
    async copyMapping(mapping) {
      await this.cancelEdit();
      await this.startEdit(mapping);
      this.form.action = mapping.action;
      this.form.shared = false; // !! important
      this.isEditing = false;
      this.showForm = true;
      this.editingId = null;
    },
    async startEdit(mapping) {
      this.editingId = mapping._id;
      this.isEditing = true;
      this.form = {
        action: mapping.action,
        apiShortId: mapping.apiShortId,
        promptShortId: mapping.promptShortId,
        shared: mapping.shared
      };
      this.showForm = true;
    },
    async cancelEdit() {
      this.editingId = null;
      this.isEditing = false;
      this.form = {
        action: "",
        apiShortId: "",
        promptShortId: "",
        shared: false
      };
      this.showForm = false;
    }
  },
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    }
  },
  watch: {
    currentPrincipal() {
      this.fetchData();
    }
  }
};
